/** These query fields preserve a work-chat selection across account pages. */
export function workspaceContextQuery(search: string): string {
  const source = new URLSearchParams(search);
  const context = new URLSearchParams();
  for (const key of ['chat', 'agent', 'role']) {
    const value = source.get(key);
    if (value !== null) context.set(key, value);
  }
  const query = context.toString();
  return query ? `?${query}` : '';
}
